import AuthContext from "../context/authContext";
import { useNavigate, useLocation } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import {deleteWebuserId, getEntities, getEntityTypes, refreshDirectReports} from "../helpers/tableauUserHelpers";
import { postResetPassword } from "../helpers/tableauAccountHelpers";
import EmployeeAccountViewPanel from "./employeeAccountViewTab";
import { userAccountUnlock } from "../helpers/updateAccountInformation";
import { Container } from "react-bootstrap";
import { format, parseISO } from "date-fns";

import AddEditUserModal from "./addEditUserModal";
import AddEntityModal from "./addEntityModal"
import TimeOutDialog from "./timeoutDialog";

import appBarCloseImg from "../content/img/appbar.close.png";
import lockImg from "../content/img/lock.png";
import unLockImg from "../content/img/unlock.png";
import logo from "../content/img/logo-header.png";
import homeImg from "../content/img/home.svg";
import logoutImg from "../content/img/exit.png";
import { BsFillTrashFill, BsFillPencilFill, BsArrowCounterclockwise, BsUnlock, BsLock} from "react-icons/bs";

import 'react-tabs/style/react-tabs.css';
import '../content/ccbh-tableau-portal_2.0.css';
import { formatPhone } from "../scripts/ccbh";
import { ccbhmessagebox, removeMsg } from "../scripts/ccbh.ui";
import '../content/ccbh.ui.css';
import { addStat, postUserStat } from "../helpers/statHelpers";

/**
 * User table page
 * 
 * @version 1.0.0
 * @author ROD
 * @param {boolean} showPageHeader - Show the page header. Default: true.
 * @parram {string} userModalMode - Page mode, either 'Edit' (edit existing user) or 'Add' (add new user). Default: 'Edit'.
 * @returns Page
 */
const UserSettings = ({showPageHeader = true, usrModalMode = 'Edit'}) => {
    let navigate = useNavigate();
    const { logout } = useContext(AuthContext);
    const location = useLocation();

    const [lockImageStateIndex, setLockImageStateIndex] = useState(0);
    const imgList = [lockImg, unLockImg];
    const [pageHeaderId, setPageHeaderId] = useState('NoShow'); //vertical-nobar
    
    const loginResult = location.state?.loginResult;
    const user = location.state?.loginResult.user;
    
    const [userFirstName, setUserFirstName] = useState(user.firstName);
    const [userLastName, setUserLastName] = useState(user.lastName);
    const [userEmail, setUserEmail] = useState(user.email);
    const [userPhone, setUserPhone] = useState(user.phoneNumber);
    const [selectedEmployee, setSelectedEmployee] = useState('');
    const [selectedEmployeeFullName, setSelectedEmployeeFullName] = useState('');
    const [selectedEmployeeEntity, setSelectedEmployeeEntity] = useState(user.tableauEntities[0].id);
    const [selectEmployeeEntityType, setSelectedEmployeeEntityType] = useState(user.tableauEntities[0].type);
    const [directReportsList, setDirecReportsList] = useState(user.directReportEmployees);

    const [entitiesList, setEntitiesList] = useState('');
    const [entityTypeList, setEntityTypeList] = useState('');
    const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
    const [entityOptions, setEntityOptions] = useState('');
    const [entityTypeOptions, setEntityTypeOptions] = useState('');
    const [openAddEditUserModal, setOpenAddEditUserModal] = useState(false);
    const [openAddEntityModal, setOpenAddEntityModal] = useState(false);
    const [tabIndex, setTabIndex] = useState(0);
    const [userModalMode, setUserModalMode] = useState(usrModalMode);
    
    /**
     * Goto to the Dashboard List Page
     * @param {*} loginResp 
     */
    const goDashboardList = (loginResp) => {
        navigate("/dashboardlist", {state: {id:1, name:'test', loginResult: loginResp}});
    };

    /**
     * Get list of Contract Entites
     * @returns List<EntityObject>
     */
    const fetchEntities = async() => {
        return await getEntities(user.authorization);
    };

    /**
     * Get list of EntityTypes
     * @returns List<EntityType>
     */
    const fetchEntityTypes = async() =>{
        return await getEntityTypes(user.authorization);
    };

    /**
     * Timeout Dialog
     */
    const timeoutDiv = TimeOutDialog();

    /**
     * Create list of Entities Options for Select List
     * @param {string} type 
     * @param {string} id 
     * @param {string} name 
     * @param {boolean} isSelected 
     * @returns 
     */
    const entityListOption = (type, id, name, isSelected) =>{
        const value = type + ":" + id + ":" + name;
        var selected='';
        if(isSelected){
            selected = "selected";
        }
        
        return (
            <option value={value} selected={selected}>{name}</option>
        )
    };

    /**
     * Create list of EntityType options for Select List
     * @param {string} id 
     * @param {string} name 
     * @param {boolean} isSelected 
     * @returns 
     */
    const entityTypeListOption = (id, name, isSelected) => {
        var selected='';
        if(isSelected){
            selected = "selected";
        }
        
        return(
            <option value={id} selected={selected} >{name}</option>
        )
    };
    
    function lockUnlockAcountInfo() {
        const elem = document.getElementById('lock_unlock_account_info');
    
        var imageIdx = lockImageStateIndex;
    
        var img = elem.src;
        if (imageIdx === 0) {
            setAccountWidgetReadOnly(false);
            setLockImageStateIndex(1);
        } else {
            setAccountWidgetReadOnly(true);
            setLockImageStateIndex(0);
        }
    };
    
    function setAccountWidgetReadOnly(ro) {
        if (ro === true) {
            document.getElementById('user-firstname').setAttribute("disabled", "true");
            document.getElementById('user-lastname').setAttribute("disabled", "true");
    
            document.getElementById('email').setAttribute("disabled", "true");
            document.getElementById('phone').setAttribute("disabled", "true");
            document.getElementById("user_update_account_info").disabled = true;

        } else {
            document.getElementById('user-firstname').removeAttribute("disabled");
            document.getElementById('user-lastname').removeAttribute("disabled");
    
            document.getElementById('email').removeAttribute("disabled");
            document.getElementById('phone').removeAttribute("disabled");
        }
    };

    function userLogout(){
        console.log("User clicked Logout");
        logout();
        navigate("/", {state: {id:3, name:"SessionTimeOut", loginResult: null}});
    };

    function show(){
        return null;
    };
        
    useEffect(() =>{
        if(showPageHeader === true){
            setPageHeaderId('vertical-nobar');
        }

        fetchEntities().then((nts) =>{
            setEntitiesList(nts);
            console.log(nts);
            setEntityOptions(nts.map((n) => entityListOption(n.type, n.id, n.name, (n.id === selectedEmployeeEntity) )));
        });

        fetchEntityTypes().then((et) => {
            setEntityTypeList(et);
            console.log(et);
            setEntityTypeOptions(et.map((e) => entityTypeListOption(e.id, e.name, (e.id === selectEmployeeEntityType) )));
        });
    }, []);

    const getEmployeeInformation = (employeeWebuserId) => {
        console.log("Double Click");
        const employee = directReportsList.find((emp) =>{
            if(emp.webuserId === employeeWebuserId){
                return emp;
            }
        });
        
        setUserModalMode('Edit');
        setSelectedEmployee(employee);
        setSelectedEmployeeFullName(employee.lastName + ", " + employee.firstName);

        setOpenAddEditUserModal(true);
        setOpenAddEntityModal(false);
        refreshTable();
        postUserStat(user.authorization, user.webuserId, 'Add/Edit User List', 'Edit User', '', '', '', employeeWebuserId);
    };

    const addNewEmployee = () => {
        setUserModalMode('Add');
        setSelectedEmployee('');
        setOpenAddEditUserModal(true);
        setOpenAddEntityModal(false);
        refreshTable();
        postUserStat(user.authorization, user.webuserId, 'Add/Edit User List', 'Add User', '', '', '', '');
    };

    const deleteEmployee = (employeeWebuserId) => {
        ccbhmessagebox({
            message: "Are you sure you want to delete this user?",
            title: "Delete User Confirmation",
            modal: true,
            closebutton: false,
            buttons: {
                'Yes': function (){
                    deleteWebuserId(user.authorization, employeeWebuserId);
                    onEmployeeEdit();
                    removeMsg();
                    refreshTable();
                    postUserStat(user.authorization, user.webuserId, 'Delete User Modal', 'Delete User', '', '', '', employeeWebuserId);
                },
                'No': function (){
                    postUserStat(user.authorization, user.webuserId, 'Delete User Modal', 'Cancel', '', '', '', employeeWebuserId);
                    removeMsg();
                }
            }
        });
    };

    const resetUserPassword = async(username) => {
        postUserStat(user.authorization, user.webuserId, 'Add/Edit User List', 'Password Reset', '', '', '', '');
        ccbhmessagebox({
            message: "Click YES to have a password reset email sent to address on file.",
            title: "Reset User Password",
            modal: true,
            closebutton: false,
            buttons:{
                'Yes': async function (){
                    const response = await postResetPassword(user.authorization, username);
                    console.log('pass reset response:' + response);

                    if(response.success === true){
                        ccbhmessagebox({
                            message: "Email has been sent.",
                            title: "Reset email confirmation",
                            modal: true,
                            closebutton: false,
                            buttons:{
                                'Ok': function(){
                                    removeMsg();
                                    //addStat(user.authorization, user.webuserId, 'Password Reset', 'Sent: ' + username);
                                    postUserStat(user.authorization, user.webuserId, 'Password Reset Modal', 'Password Reset', '', '', '', username);
                                }
                            }
                        });
                    }else{
                       ccbhmessagebox({
                        title: "Email Sending Error",
                        message: "There was a problem sending the email to the registered address. Please contact adminitractor at: DataMine.ccbh.com",
                        modal: true,
                        closebutton: false,
                        buttons:{
                            'Ok': function(){
                                removeMsg();
                            }
                        }
                       }); 
                    }


                },
                'No': function(){
                    removeMsg();
                    //addStat(user.authorization, user.webuserId, 'Password Reset', 'Cancelled: ' + username);
                    postUserStat(user.authorization, user.webuserId, 'Password Reset Modal ', 'Cancel', '', '', '', username);
                }
            }
        })
    };

    const unlockUser = async(webuserId) => {
        ccbhmessagebox({
            message: "To unlock the user account click YES.",
            title: "Unlock User Account",
            modal: true,
            closebutton: false,
            buttons:{
                'Yes': function(){
                    userAccountUnlock(user.authorization, webuserId);
                    refreshTable();
                    ccbhmessagebox({
                        message: "User account " + webuserId + " unlocked.",
                        title: "User Account Unlocked",
                        modal: true,
                        closebutton: false,
                        buttons:{
                            'Ok': function(){
                                removeMsg();
                                //addStat(user.authorization, user.webuserId, 'Account Unlocked', webuserId);
                                postUserStat(user.authorization, user.webuserId, 'Account Unlock Modal ', 'Account Unlocked', '', '', '', webuserId);
                            }
                        }
                    });
                },
                'No': function(){
                    removeMsg();
                    //addStat(user.authorization, user.webuserId, 'Account Unlocked', 'Canceled for: ' + webuserId);
                    postUserStat(user.authorization, user.webuserId, 'Account Unlock Modal ', 'Cancel', '', '', '', webuserId);
                }
            }
        });
    };

    const onEmployeeEdit = async(cancel) => {
        if((cancel === null) || (cancel === undefined)){
            //setDirecReportsList(null);
            //user.directReportEmployees = null;
            //let dr  = await refreshDirectReports(user.webuserId);
            //user.directReportEmployees = dr;
            //setDirecReportsList(dr);
            
            //refreshTable();
        }
    };

    const refreshTable = async() => {
        let dr = await refreshDirectReports(user.authorization, user.webuserId);
        user.directReportEmployees = dr;
        setDirecReportsList(dr);
    };

    const [currentSortOrder, setCurrentSortOrder] = useState('ascending');
    const onSortColumn = (sortCol) =>{
        var sortData = [];
        if(currentSortOrder === 'ascending'){
            if(sortCol === 'lastName'){
                sortData = [...directReportsList].sort((a, b) => (b.lastName.localeCompare(a.lastName)));
            }else if(sortCol === 'role'){
                sortData = [...directReportsList].sort((a, b) => (b.title.localeCompare(a.title)));
            }else if(sortCol === 'lastActive'){
                sortData = [...directReportsList].sort((a, b) => (new Date(b.lastLoginDate) - new Date(a.lastLoginDate)));
            }else if(sortCol === 'added'){
                sortData = [...directReportsList].sort((a, b) => (b.origEntryChron > a.origEntryChron ? -1 : 1));
            }else if(sortCol === 'active'){
                sortData = [...directReportsList].sort((a, b) => (b.enabled > a.enabled ? -1 : 1 ));
            }

            setDirecReportsList(sortData);
            setCurrentSortOrder('decending');
        }else{
            if(sortCol === 'lastName'){
                sortData = [...directReportsList].sort((a, b) => (a.lastName.localeCompare(b.lastName) ));
            }else if(sortCol === 'role'){
                sortData = [...directReportsList].sort((a, b) => (a.title.localeCompare(b.title)));
            }else if(sortCol === 'lastActive'){
                sortData = [...directReportsList].sort((a, b) => (new Date(a.lastLoginDate) - new Date(b.lastLoginDate)));
            }else if(sortCol === 'added'){
                sortData = [...directReportsList].sort((a, b) => (a.origEntryChron > b.origEntryChron ? -1 : 1));
            }else if(sortCol === 'active'){
                sortData = [...directReportsList].sort((a, b) => (a.enabled > b.enabled ? -1 : 1 ));
            }
            setDirecReportsList(sortData);
            setCurrentSortOrder('ascending');
        }
    };

    const unlockSpan = (isCzar, webuserId, locked) => {
        if(isCzar){
            if(locked){
                return(
                    <span title="unlock user account" id="unlock-user-img">
                        <BsLock onClick={() => {
                            unlockUser(webuserId);
                        }} />
                    </span>
                );
            }else{
            
                return(
                    <span title="unlock user account" id="unlock-user-img">
                        <BsUnlock />
                    </span>
                );
            }
        }
    };

    const employeeAccountListPanel = () => {
        return (
            <>
            <div className="" id="admin-user-accounts">
                <h3 className="">{user.tableauEntities[0].name}({user.tableauEntities[0].id}) User: {directReportsList?.length}</h3>
                <div className="shadow-talk-modal">
                        <div id="table-buttons">
                            <input type='button' id='add-new-user' title="Add New User Account" value="Add User" onClick={() => {addNewEmployee();} }/>           
                            <input type="button" id="refresh-table" title="Refresh User List" value="Refresh" onClick={() => {refreshTable();}} />
                        </div>

                        <table id="direct-reports">
                                <tr>
                                    <th className="direct-reports-username" onClick={() => {onSortColumn('lastName');}} >User Name</th>
                                    <th className="direct-reports-firstname center sortable" onClick={() => {onSortColumn('role');}} >Role</th>
                                    <th className="sortable" onClick={() => {onSortColumn('lastActive');}}>Last Active</th>
                                    <th className="sortable" onClick={() => {onSortColumn('added');}}>Date Added</th>
                                    <th className="center">Actions</th>
                                </tr>
                                    {directReportsList?.map(e =>  {
                                    const fullname = e.lastName + ", " + e.firstName;
                                    var isActive = "";
                                    if(e.enabled === true){
                                        isActive = "checked";                                        
                                    }
                                    var lastLogin = "";
                                    if(e.lastLoginDate !== null){
                                        lastLogin = format(parseISO(e.lastLoginDate), "MMM d, yyyy");
                                    }
                                    let locked = false;
                                    if(e.consecutiveFailedLogin >= 10){
                                        locked = true;
                                    }

                                    var uSpan = unlockSpan(user.isCzar, e.webuserId, locked); 

                                    return(
                                        <>
                                        <tr className="direct-reports-row" key={e.webuserId}>
                                            <td className="direct-reports-username" name="direct-reports-username" id="direct-reports-username" onDoubleClick={() => {getEmployeeInformation(e.webuserId)}}>
                                                <b>{fullname}</b> ({e.webuserId})<br />
                                                {e.email}
                                            </td>
                                            <td className="direct-reports-firstname center" name="direct-reports-firstname" id="direct-reports-firstname">
                                                {e.title}
                                            </td>
                                            <td className="">
                                                {lastLogin}
                                            </td>
                                            <td className="">
                                                {format(parseISO(e.origEntryChron), "MMM d, yyyy")}
                                            </td>
                                            
                                            <td className="center">
                                                <span title="Delete User" id="delete-user-img" >
                                                    <BsFillTrashFill onClick={() => {
                                                        deleteEmployee(e.webuserId);
                                                    }} />
                                                </span>
                                                <span title="Edit User" id="edit-user-img">
                                                    <BsFillPencilFill onClick={() => {
                                                        getEmployeeInformation(e.webuserId);                                                        
                                                    }} />
                                                </span>
                                                <span title="Send Reset Password Link" id="reset-pwd-img">
                                                    <BsArrowCounterclockwise onClick={() =>{
                                                        resetUserPassword(e.webuserId);
                                                    }}/>
                                                </span>

                                               {uSpan}

                                            </td>
                                        </tr>
                                        </>
                                        )
                                    })}    
                        </table>
                        {openAddEntityModal && 
                        <AddEntityModal closeModal={() => {
                            setOpenAddEntityModal(false);
                        }}
                        />
                        }
                </div>
            </div>
            
            </>
        )
    };

    const empViewPanel = EmployeeAccountViewPanel(user);
    const empTable = employeeAccountListPanel(user);

    return (
        <>
        {/* userSettingsPage */}
        <Container className="">
            <div id={pageHeaderId} name="top-bar" >
                <img id="logo" name="logo" src={logo} alt="Community Care Behavioral Health Organization" onClick={() => show()} />

                <span id="left-side-vertical-app-buttons">
                    <span className="left-side-button" onClick={() => goDashboardList(loginResult)} >
                        <img id="favorite-reports" className="button-img" src={homeImg}  />
                        <label className="nav-label">Dashboard List</label>
                    </span>
 
                    <hr id="menuHr" width="90%" />
                    <span className="left-side-button" onClick={() => userLogout()} >
                        <img id="user-logout" className="button-img-exit" src={logoutImg} />
                        <label className="nav-label">Log Out</label>
                    </span>
                </span>
            </div>

            <div className="settings-Detail-Div">
                {empTable}
            </div>
        </Container>
        
        <div id="settings-main-wrapper"   >
            <div id="xxx-account-settings" className="">
                    <input type="hidden" id="page-name" name="page-name" defaultValue="AdminAccount" />
                    <input type="hidden" id="pwd_change" name="pwd_change" defaultValue="@FirstTime" />

                    <div id="account-error-div" className="error-section">
                        <h2 className="error-section-title">PLEASE FIX THE FOLLOWING ERRORS</h2>
                        <div id="page-error-section">
                            <ul>
                                {/*@foreach (KeydefaultValuePair<string, string> err in error_dict) {
                                    <li><label className="page-error">@err.defaultValue</label><br /></li>
                                } */}
                            </ul>
                        </div>
                    </div>
                    <div className="shadow-title" id="user-account-title-bar">
                        <img src={appBarCloseImg} id="close-account-management" name="close-account-management" onClick={() => {navigate(-1)}} />
                    </div>
                    { /* @if (canManagerUsers) { */}
                    <Tabs id="admin-account-settings-bar" selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
                        <TabList id="inner_nav_div">
                            <Tab className="pageLinkSelected" id="admin-account-info" title="Switch to Personal Account Administration View" >
                                Edit Account Information
                            </Tab>

                            <Tab className="pageLink" id="admin-employee-account" title="Switch To User Account Administration View" >
                                User Account View
                            </Tab>
                        </TabList>
                           <TabPanel>
                            <div id="settings-form-wrapper">
                                <div>
                                    <img className="selectable-img" id="lock_unlock_account_info" name="lock_unlock_account_info" src={imgList[lockImageStateIndex]} onClick={() => {lockUnlockAcountInfo(this)}} title="Edit Personal Account Information" /> 
                                </div>
                                <br />
                            </div>    
                           </TabPanel>

                           <TabPanel>
                                {empViewPanel}
                           </TabPanel>
                    </Tabs>
            </div>
        </div>

        {openAddEditUserModal && 
                <AddEditUserModal closeModal={(cancel) => {
                    setOpenAddEditUserModal(false);
                    onEmployeeEdit(cancel);
                }}
                user={user}
                selectedEmployee={selectedEmployee}
                refreshDirectReportList={refreshTable}
                modalMode={userModalMode}
                />
            }


        {timeoutDiv}
        </>
    );
};

export default UserSettings;